(function () {
    'use strict';

    angular.module("imApp").factory("requisitionToConsignmentService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 768,
                    parameters: parms || {}
                });
            },
            listRequisitionToConsignments: function (parms) {
                return $ihttp.post({
                    method: 769,
                    parameters: parms || {}
                });
            },
            createRequisitionToConsignments: function (mergeObj) {
                return $ihttp.post({
                    method: 770,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
